import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { EditMemberForm } from '../EditMemberForm'
import { useParams, Navigate } from 'react-router-dom'
import { useIsCurrentUser } from '@/modules/manage-member/hooks/useIsCurrentUser'
import showErrorToast from '@/common/utils/showErrorToast'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function EditMemberListing() {
	const { id } = useParams()
	const isCurrentUser = useIsCurrentUser(id!)

	if (isCurrentUser) {
		showErrorToast('ไม่สามารถแก้ไขบัญชีของตัวเองได้')
		return <Navigate to="/operator/manage-member" replace />
	}

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`แก้ไขผู้ดูแลระบบ`} description="แก้ไขผู้ดูแลระบบ" />
				<NavigateBackButton />
			</div>
			<Separator />
			<EditMemberForm />
		</div>
	)
}
